import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 10px;
`;

const Banner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  background-color: #fffbe5;
  padding: 7px 15px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px 15px;
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    .badges-list {
      align-self: flex-end;
    }
  }
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 24px;
  flex: 1;
`;

const Badges = styled.div`
  display: flex;
  gap: 20px;
`;

const Badge = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  i {
    font-size: 20px;
  }
  > div {
    display: flex;
    align-items: center;
    gap: 5px;
    font-weight: bold;
  }
  span {
    font-size: 13px;
    color: #777;
    margin-top: 2px;
  }
`;

export default ({ location: { displayInfo }, location }) => {
  const displayPromoDetail =
    !location.aptlyScreening?.active && location.showPromoBanner && location.promoDetail;

  return (
    <Wrapper>
      <Banner>
        <div>
          Available{' '}
          <strong>
            {!displayInfo.formattedAvailableDate ? 'NOW' : displayInfo.formattedAvailableDate}
          </strong>
        </div>
        {displayPromoDetail && <div className="promo">{location.promoDetail}</div>}
      </Banner>
      <Row>
        <Title>{displayInfo.title}</Title>
        <Badges className="badges-list">
          {displayInfo.bedCount && (
            <Badge>
              <div>
                <i className="fa-regular fa-bed" /> {displayInfo.bedCount}
              </div>
              <span>Beds</span>
            </Badge>
          )}
          {displayInfo.bathCount && (
            <Badge>
              <div>
                <i className="fa-regular fa-bath" /> {displayInfo.bathCount}
              </div>
              <span>Baths</span>
            </Badge>
          )}
          {displayInfo.squareFeet && (
            <Badge>
              <div>
                <i className="fa-regular fa-ruler-combined" /> {displayInfo.squareFeet}
              </div>
              <span>sf</span>
            </Badge>
          )}
        </Badges>
      </Row>
    </Wrapper>
  );
};
